<template>
    <div class="video" :class="{ 'is-playing': hidePoster }">
        <Transition name="fade-in-top">
            <div
                v-if="!hidePoster"
                class="video__poster"
                :style="`background-image: url(${poster})`">
                <button class="btn-play" @click="play" type="button">
                    <svgComponent
                        :width="48"
                        :height="48"
                        class-name="icon-play"
                        icon-name="icon-play"></svgComponent>
                </button>
            </div>
        </Transition>

        <vueVimeoPlayer
            class="video__player"
            ref="elPlayer"
            @ended="onEnded"
            @loaded="onLoaded"
            :video-id="url"
            :options="{ width: 1280, height: 720 }"></vueVimeoPlayer>
    </div>
    <div class="video-info">
        <div class="title">
            {{ title }}
        </div>
        <div class="duration">
            {{ duration }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';
import svgComponent from '../../components/svgComponent.vue';
import { vueVimeoPlayer } from 'vue-vimeo-player';
import { HTMLVimeoIFrameElement } from './model/VimeoIframeElement';
const elPlayer: Ref<HTMLVimeoIFrameElement | null> = ref(null);
const hidePoster: Ref<boolean> = ref(false);
const loaded: Ref<boolean> = ref(false);

defineProps<{
    url: string;
    title: string;
    duration: string;
    poster: string;
}>();

function play() {
    hidePoster.value = !hidePoster.value;

    if (loaded.value && elPlayer.value) {
        elPlayer.value.unmute();
        elPlayer.value.play();
    }
}

function onEnded() {
    hidePoster.value = !hidePoster.value;
}

function onLoaded() {
    loaded.value = !loaded.value;
}
</script>
